import Skeleton from 'react-loading-skeleton';

import { useCancelNumberReservation } from '@/api';
import { Button } from '@/components/shared/Button';
import { useChosenNumberStore, useModalStore } from '@/store';
import { formatNumber } from '@/utils';

import cn from './styles.module.sass';

export const ReservationCancelContent = () => {
    const { chosenNumber, clearOnUnmount } = useChosenNumberStore();
    const { setIsCancelReservationOpen } = useModalStore();
    const { mutateAsync: cancelReservation, isPending } = useCancelNumberReservation();

    const handleClick = async () => {
        if (chosenNumber?.number) {
            const res = await cancelReservation(formatNumber(chosenNumber.number, true));

            if (res.success) {
                setIsCancelReservationOpen(false);
                clearOnUnmount();
            }
        }
    };

    return (
        <div className={cn.container}>
            <h2>Отменить бронь</h2>
            <div className={cn.description}>
                <p>Отменить бронь для номера</p>
                <p>
                    <span className={cn.phone}>{chosenNumber?.number || <Skeleton />}</span> ?
                </p>
            </div>

            {isPending ? (
                <Skeleton height={48} />
            ) : (
                <Button onClick={handleClick}>Да, я хочу отменить бронь</Button>
            )}
        </div>
    );
};
